import React from "react";
import Button from "@scripts/react/components/Button";
import { TooltipContainer } from "@scripts/react/components/Tooltip";
import { ButtonType } from "@scripts/react/components/Button";
import { twClassNames } from "@scripts/react/helpers/twClassNames";

interface FloatingNavigationControlsProps {
    onPrevious: () => void;
    onNext: () => void;
    showKeyboardHints?: boolean;
    buttonType?: ButtonType;
    disabled?: boolean;
    horizontalControls?: boolean;
}

export function FloatingNavigationControls({
    onPrevious,
    onNext,
    showKeyboardHints = true,
    buttonType = "secondary",
    disabled = false,
    horizontalControls = true
}: FloatingNavigationControlsProps) {
    return (
        <>
            <TooltipContainer
                type="titleOnly"
                title={
                    <div>
                        Previous{" "}
                        {showKeyboardHints && (
                            <span className="hotkey dark ml-1">
                                {horizontalControls ? "←" : "↑"}
                            </span>
                        )}
                    </div>
                }
                placement={horizontalControls ? "top" : "left"}
                customButton={
                    <span
                        className={twClassNames(
                            "absolute top-1/2 z-10",
                            horizontalControls ? "left-8 -translate-y-1/2" : "left-4 -translate-y-6"
                        )}
                    >
                        <Button
                            className="border-opacity-50 shadow-lg hover:scale-105"
                            shape="circle"
                            type={buttonType}
                            size="large"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                onPrevious();
                            }}
                            disabled={disabled}
                        >
                            <i
                                className={
                                    horizontalControls ? "far fa-chevron-left" : "fa fa-chevron-up"
                                }
                            />
                        </Button>
                    </span>
                }
            />

            <TooltipContainer
                type="titleOnly"
                title={
                    <div>
                        Next{" "}
                        {showKeyboardHints && (
                            <span className="hotkey dark ml-1">
                                {horizontalControls ? "→" : "↓"}
                            </span>
                        )}
                    </div>
                }
                placement={horizontalControls ? "top" : "left"}
                customButton={
                    <span
                        className={twClassNames(
                            "absolute top-1/2 z-10",
                            horizontalControls ? "right-8 -translate-y-1/2" : "left-4 translate-y-6"
                        )}
                    >
                        <Button
                            className="border-opacity-50 shadow-lg hover:scale-105"
                            shape="circle"
                            type={buttonType}
                            size="large"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                onNext();
                            }}
                            disabled={disabled}
                        >
                            <i
                                className={
                                    horizontalControls
                                        ? "far fa-chevron-right"
                                        : "fa fa-chevron-down"
                                }
                            />
                        </Button>
                    </span>
                }
            />
        </>
    );
}
